module.exports = __webpack_public_path__ + "static/media/mario-friarCut.5001bfeb.svg";